/* eslint-disable import/prefer-default-export */
import store from '../store';

export function auth() {
    return { headers: { Authorization: `Token ${store.state.user.token}` } };
}
